export default "__VITE_ASSET__Ccng8atu__"